import { render } from "./TestDataView.vue?vue&type=template&id=50cb37ca"
import script from "./TestDataView.vue?vue&type=script&lang=js"
export * from "./TestDataView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__